import {
  ChartOptions,
  ArcElement,
  Chart as ChartJS,
  ChartType,
  Tooltip,
  Legend
} from 'chart.js';
import React from 'react';
import { Pie } from 'react-chartjs-2';

ChartJS.register([ArcElement, Tooltip, Legend])

interface PieChartRiskProps {
  firstTitle: string;
  secondTitle: string;
  firstValue: number;
  secondValue: number;
}

export default function PieChartRisk(props: PieChartRiskProps) {
  const { firstTitle, firstValue, secondValue, secondTitle } = props;
  const data = {
    labels: [firstTitle, secondTitle],
    datasets: [
      {
        label: '',
        data: [firstValue, secondValue],
        backgroundColor: ['#625BA6', '#79BEAE'],
        borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
        borderWidth: 1,
      },
    ],
  };
  const chartTooltip = {
    callbacks: {
      title: function (a: any) {
        return a.label ?? '';
      },
    },
    backgroundColor: '#1C174D',
    titleFontSize: 16,
    titleFontColor: '#0066ff',
    bodyFontColor: '#000',
    bodyFontSize: 14,
    displayColors: true,
    footerFontSize: 2,
  };

  const options = {
    type: 'pie' as ChartType,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'center'
      },
      maintainAspectRatio: false,
      tooltip: chartTooltip,
    },
  } as ChartOptions<'pie'>;

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{ maxWidth: 360 }}>
        <Pie data={data} width={250} height={250} options={options} />
      </div>
    </div>
  );
}
